export const CHECK_DASHBOARD_DATA = 'src/Corporate/dashboard/action/Check_Dashboard_Data';
export const CHECK_DASHBOARD_DATA_SUCCESS = 'src/Corporate/dashboard/action/Check_Dashboard_Data_Success';
export const CHECK_DASHBOARD_DATA_FAILURE = 'src/Corporate/dashboard/action/Check_Dashboard_Data_Failure';
export const checkDashboardData = (data) => {
    return {
        type: CHECK_DASHBOARD_DATA,
        data
    }
}
export const checkDashboardDataSuccess = (data) => {
    return {
        type: CHECK_DASHBOARD_DATA_SUCCESS,
        data
    }
}
export const checkDashboardDataFailure = (data) => {
    return {
        type: CHECK_DASHBOARD_DATA_FAILURE,
        data
    }
}


export const GET_DASHBOARD_DATA = 'src/Corporate/dashboard/action/Get_Dashboard_Data';
export const GET_DASHBOARD_DATA_SUCCESS = 'src/Corporate/dashboard/action/Get_Dashboard_Data_Success';
export const GET_DASHBOARD_DATA_FAILURE = 'src/Corporate/dashboard/action/Get_DashBoard_Data_Failure';
export const getDashboardDataSuccess = (data) => {
    return {
        type: GET_DASHBOARD_DATA_SUCCESS,
        data
    }
}
export const getDashboardDataFailure = (error) => {
    return {
        type: GET_DASHBOARD_DATA_FAILURE,
        error
    }
}

export const getDashboardData = (data) => {
    return {
        type: GET_DASHBOARD_DATA,
        data
    }
}

export const SET_FILTERS = 'src/Corporate/dashboard/action/Set_Filters';
export const setFilters = (data) => {
    return {
        type: SET_FILTERS,
        data
    }
}


export const GET_CASE_COUNT_BY_STATE = 'src/Corporate/dashboard/action/Get_Case_Count_By_State';
export const GET_CASE_COUNT_BY_STATE_SUCCESS = 'src/Corporate/dashboard/action/Get_Case_Count_By_State_Success';
export const GET_CASE_COUNT_BY_STATE_FAILURE = 'src/Corporate/dashboard/action/Get_Case_Count_By_State_Failure';
export let caseCountByStateData="";

export const getCaseCountByStateSuccess = (data) => {
    caseCountByStateData = data;
    return {
        type: GET_CASE_COUNT_BY_STATE_SUCCESS,
        data
    }
}
export const getCaseCountByStateFailure = (error) => {
    return {
        type: GET_CASE_COUNT_BY_STATE_FAILURE,
        error
    }
}

export const getCaseCountByState = (data) => {
    return {
        type: GET_CASE_COUNT_BY_STATE,
        data
    }
}
